export const REGISTRADO = 1;
export const ANULADO = 2;
export const IMPORTADO = 3;
export const EMITIDO = 4;
export const RECHAZADO = 5;